// extracted by mini-css-extract-plugin
export default {"stats":"programMain_stats__fU9UR","controlUnit":"programMain_controlUnit__6T93V","icon":"programMain_icon__fi8dd","requests":"programMain_requests__-f7EZ"};